// Power-up activation/expiry (v1 game3d.js:1086-1125). One active at a time;
// star = invincibility, multiplier = 2× score, magnet = 4× attraction radius.

import { POWER_UP_TYPES, MAGNET_RADIUS_MULTIPLIER, type PowerUpId } from '@/content/powerups';
import type { RunState } from '@/app/context';
import type { EventBus } from '@/app/events';

export function activatePowerUp(run: RunState, bus: EventBus, typeId: PowerUpId): void {
  deactivatePowerUp(run, bus); // Replace any active power-up first (v1 :1091)

  const def = POWER_UP_TYPES[typeId];
  run.activePowerUpId = typeId;
  run.powerUpTimer = def.duration;
  // Strong Magnet modifier: +2s on the mega magnet (Phase 6 shop)
  if (typeId === 'magnet' && run.modifiers.has('mod-magnet-plus')) run.powerUpTimer += 2;

  if (typeId === 'star') run.isInvincible = true;
  else if (typeId === 'multiplier') run.powerUpScoreMultiplier = 2.0;
  else run.magnetRadiusMultiplier = MAGNET_RADIUS_MULTIPLIER;

  bus.emit('powerup:activated', { typeId });
}

export function deactivatePowerUp(run: RunState, bus: EventBus): void {
  if (!run.activePowerUpId) return;
  run.isInvincible = false;
  run.powerUpScoreMultiplier = 1.0;
  run.magnetRadiusMultiplier = 1.0;
  run.activePowerUpId = null;
  run.powerUpTimer = 0;
  bus.emit('powerup:deactivated', {});
}

export function updatePowerUpTimer(run: RunState, bus: EventBus, dt: number): void {
  if (!run.activePowerUpId) return;
  run.powerUpTimer -= dt;
  bus.emit('powerup:tick', { remaining: Math.max(0, run.powerUpTimer) });
  if (run.powerUpTimer <= 0) deactivatePowerUp(run, bus);
}
